import type { JSX, PropsWithChildren } from 'react';

import { SocialProof } from 'src/app/pages/petitionGamma/details/shared/components';

type Props = {
	sticky: boolean;
	visible: boolean;
	hideSocialProof?: boolean;
};

export function ActionButtonWrapper({
	children,
	sticky,
	visible,
	hideSocialProof = false,
}: PropsWithChildren<Props>): JSX.Element {
	if (!sticky) {
		return <div>{children}</div>;
	}

	const wrapperVisibilityClasses = visible ? 'bottom-0 focus-within:bottom-0' : 'bottom-[-1000px]';

	return (
		// this approach ensures the button follows the `visible` flag even after it has been focused, while
		// still preventing outlines from appearing around the wrapper when focus is managed programmatically.
		<div
			className={`fixed left-0 z-[2000] w-full shadow-[0px_-0.7px_1.4px_rgba(0,0,0,0.07),_0px_-1.9px_4px_rgba(0,0,0,0.05),_0px_-4.5px_10px_rgba(0,0,0,0.05),_0px_-15px_32px_rgba(0,0,0,0.04)] focus-within:outline-none ${wrapperVisibilityClasses}`}
		>
			<div className={`bg-[#F2F2F2] px-4 pb-2 ${hideSocialProof ? 'pt-2' : 'pt-0'}`}>
				{!hideSocialProof && <SocialProof />}
				{children}
			</div>
		</div>
	);
}
